export default __webpack_public_path__ + "static/media/Resume.70151564.mp3";